import React, { useState } from 'react';
import {
  Menu,
  Typography,
  Divider,
  makeStyles,
  CircularProgress
} from '@material-ui/core';
import { Button } from '@synergy-marine-group/synergy-ui';

const useStyles = makeStyles((theme) => ({
  menuPaper: {
    borderRadius: 8,
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
    padding: theme.spacing(1),
    minWidth: 220
  },
  sectionTitle: {
    fontSize: '14px',
    fontWeight: 600,
    fontFamily: 'Mulish, sans-serif',
    color: '#6e7194',
    padding: '6px 16px 4px',
    textTransform: 'uppercase'
  },
  inlineLinks: {
    display: 'flex',
    justifyContent: 'space-between',
    fontFamily: 'Mulish, sans-serif',
    padding: '4px 16px',
    fontSize: '14px',
    fontWeight: 500,
    paddingInline: '28px',
    color: '#4a4a4a',
    cursor: 'pointer',
    textDecoration: 'underline',
    textDecorationColor: '#9a9595',
    gap: '8px'
  },
  divider: {
    margin: theme.spacing(1, 0)
  }
}));

const ExportCCVButton = ({ onClickOption, policies, disabled, vesselPolicies, agencyPolicies }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const hasAgencyAccess = !!(agencyPolicies ?? policies?.agencyPoPolicies?.canAccess);

  const handleOpen = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleItemClick = (type) => {
    handleClose();
    onClickOption(type);
  };

  const showAllOption = vesselPolicies || hasAgencyAccess;

  return (
    <>
      <Button
       className="bg-white-light w-auto"
       variant="outlined"
       rounded
       size="large"
      onClick={handleOpen}
      disabled={disabled}
      >
        Export
     {disabled && <CircularProgress size={24} className="button-progress" />}
      </Button>
<Menu
  anchorEl={anchorEl}
  open={Boolean(anchorEl)}
  onClose={handleClose}
  getContentAnchorEl={null}
  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
  classes={{ paper: classes.menuPaper }}
>
  {policies?.poPolicies?.canCommittedDownload && (
    <>
      <Typography className={classes.sectionTitle}>Committed Cost Report</Typography>
      <div className={classes.inlineLinks}>
        <span onClick={() => handleItemClick('crew_report')}>Crew PO</span>
        {vesselPolicies && (
          <span onClick={() => handleItemClick('vessel_report')}>Vessel PO</span>
        )}
        {hasAgencyAccess && (
          <span onClick={() => handleItemClick('agency_report')}>Agency PO</span>
        )}
        {showAllOption && (
          <span onClick={() => handleItemClick('all_report')}>All</span>
        )}
      </div>
      <Divider className={classes.divider} />
    </>
  )}
  {policies?.poPolicies?.canExcelDownload && (
    <>
      <Typography className={classes.sectionTitle}>CSV</Typography>
      <div className={classes.inlineLinks}>
        <span onClick={() => handleItemClick('crew_csv')}>Crew PO</span>
        {vesselPolicies && (
          <span onClick={() => handleItemClick('vessel_csv')}>Vessel PO</span>
        )}
        {hasAgencyAccess && (
          <span onClick={() => handleItemClick('agency_csv')}>Agency PO</span>
        )}
        {showAllOption && (
          <span onClick={() => handleItemClick('all_csv')}>All</span>
        )}
      </div>
      <Divider className={classes.divider} />
    </>
  )}
</Menu>

    </>
  );
};

export default ExportCCVButton;
